import { render, staticRenderFns } from "./fiche-de-paie.vue?vue&type=template&id=21b84870&scoped=true&"
import script from "./fiche-de-paie.vue?vue&type=script&lang=js&"
export * from "./fiche-de-paie.vue?vue&type=script&lang=js&"
import style0 from "./fiche-de-paie.vue?vue&type=style&index=0&id=21b84870&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b84870",
  null
  
)

export default component.exports